module.exports = __webpack_public_path__ + "img/8.6d654ad4.png";